import { writable, readable } from 'svelte/store';
import { io, Socket } from "socket.io-client";
function get(key, def = "", parse = false) {
    const value = localStorage.getItem(key);
    if (!parse)
        return value || def;
    if (value === null)
        return def;
    return JSON.parse(value);
}
const storedMode = get("mode", "light");
export const mode = writable(storedMode);
mode.subscribe((value) => {
    localStorage.setItem("mode", value);
});
const socket = io("https://covid-clicker.ncp.nathanferns.xyz", { transports: ['websocket', 'polling', 'flashsocket'] });
console.log("connected!");
export const WebSocket = readable(socket);
export const GameState = writable();
export const Region = writable(-1);
export const Team = writable(0);
socket.on("gameupdate", (state) => {
    GameState.set(state);
});
